
import { RevPicker, Variants } from '@ds/components/Picker'

import { HIGHLIGHTED_PICKERS_VARIANTS } from '../HighlightedPickers/HighlightedPickers.constants'

export default {
  components: {
    RevPicker,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
      default: null,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
    to: {
      type: Object,
      default: null,
    },
    tag: {
      type: String,
      default: null,
    },
    replace: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    variant() {
      if (!this.selected || !this.selectedHighlightedPickers) {
        return Variants.Default
      }

      if (
        this.selectedHighlightedPickers.type ===
        HIGHLIGHTED_PICKERS_VARIANTS.info
      ) {
        return Variants.Info
      }

      if (
        this.selectedHighlightedPickers.type ===
        HIGHLIGHTED_PICKERS_VARIANTS.accent
      ) {
        return Variants.Accent
      }

      return Variants.Default
    },
  },
}
